import { render, staticRenderFns } from "./WxChartBarGraph.vue?vue&type=template&id=056e30c2&scoped=true"
import script from "./WxChartBarGraph.vue?vue&type=script&lang=js"
export * from "./WxChartBarGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e30c2",
  null
  
)

export default component.exports